import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { createApi } from "@reduxjs/toolkit/query/react";

export const chatApi = createApi({
    reducerPath: 'chatApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        credentials: 'include'
    }),
    endpoints: (builder) => ({
        connect: builder.mutation({
            query: (payload) => ({
                url: `whatsapp/connect/${payload.id}`,
                method: 'GET'
            })
        }),
        contacts: builder.mutation({
            query: (payload) => ({
                url: `whatsapp/contacts/${payload.id}`,
                method: 'GET'
            })
        }),
        chats: builder.mutation({
            query: (payload) => ({
                url: `whatsapp/chats`,
                method: 'POST',
                body: payload
            })
        }),
        sendMessage: builder.mutation({
            query: (payload) => ({
                url: `whatsapp/send-message`,
                method: 'POST',
                body: payload
            })
        }),
        whatsAppProfile: builder.mutation({
            query: (payload) => ({
                url: `whatsapp/profile`,
                method: 'POST',
                body: payload
            })
        }),
        whatsAppSession: builder.mutation({
            query: (payload) => ({
                url: `whatsapp/session/${payload.id}`,
                method: 'GET'
            })
        }),
        whatsAppLogout: builder.mutation({
            query: (payload) => ({
                url: `whatsapp/logout/${payload.id}`,
                method: 'GET'
            })
        }),
        markAsRead: builder.mutation({
            query: (payload) => ({
                url: 'whatsapp/mark-as-seen',
                method: 'POST',
                body: payload
            })
        }),
        getLatestMessage: builder.mutation({
            query: (payload) => ({
                url: `whatsapp/latest-message/${payload.id}`,
                method: 'GET'
            })
        }),
        groupParticipant: builder.mutation({
            query: (payload) => ({
                url: 'whatsapp/group/participants',
                method: 'POST',
                body: payload
            })
        }),
        validateWhatsAppNumber: builder.mutation({
            query: (payload) => ({
                url: 'whatsapp/validate-phone',
                method: 'POST',
                body: payload
            })
        }),
        markMessageAsRead: builder.mutation({
            query: (payload) => ({
                url: 'whatsapp/read-message',
                method: 'PATCH',
                body: payload
            })
        }),
        markMessageAsUnread: builder.mutation({
            query: (payload) => ({
                url: 'whatsapp/unread-message',
                method: 'PATCH',
                body: payload
            })
        }),
        pinMessage: builder.mutation({
            query: (payload) => ({
                url: 'whatsapp/message/pin',
                method: 'PATCH',
                body: payload
            })
        }),
        pinChat: builder.mutation({
            query: (payload) => ({
                url: 'whatsapp/chat/pin',
                method: 'PATCH',
                body: payload
            })
        }),
        getBusinessProfile: builder.mutation({
            query: (payload) => ({
                url: 'whatsapp/business-profile',
                method: 'POST',
                body: payload
            })
        }),
        uploadStatus: builder.mutation({
            query: (payload) => ({
                url: `whatsapp/upload-status`,
                method: 'POST',
                body: payload
            })
        })
    })
})

export const {
    useConnectMutation,
    useContactsMutation,
    useChatsMutation,
    useSendMessageMutation,
    useWhatsAppLogoutMutation,
    useWhatsAppProfileMutation,
    useWhatsAppSessionMutation,
    useMarkAsReadMutation,
    useGetLatestMessageMutation,
    useGroupParticipantMutation,
    useValidateWhatsAppNumberMutation,
    useMarkMessageAsReadMutation,
    useMarkMessageAsUnreadMutation,
    usePinMessageMutation,
    usePinChatMutation,
    useGetBusinessProfileMutation,
    useUploadStatusMutation
} = chatApi;
